
import { call, put, takeEvery } from "redux-saga/effects";
import { thiSinhApi } from "../../../api/tct/thiSinhApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { IThiSinh } from "../../../model/respone/tct/IThiSinh";
import { eThiSinhActionIds, IThiSinhActionTypeBase, IThiSinhActionTypes } from "../../action-types/tct/IThiSinhActions";
import { rootActions } from "../../actions/rootActions";
import { ThiSinhGenerateSBDRequest } from "../../../model/request/tct/IDanhSoBaoDanhRequest";
const mainAction = rootActions.toChucThi.thiSinh;
export function* thiSinhSaga(): any {
    yield takeEvery(eThiSinhActionIds.LOAD_START, loadWorker)
    yield takeEvery(eThiSinhActionIds.SAVE_START, saveWorker)
    yield takeEvery(eThiSinhActionIds.DELETE_START, deleteWorker)
    yield takeEvery(eThiSinhActionIds.UPDATES_START, updateWorker)
    yield takeEvery(eThiSinhActionIds.INSERTS_START, insertWorker)
    yield takeEvery(eThiSinhActionIds.GENERATE_SBD_START, generateSBDWorker)
    yield takeEvery(eThiSinhActionIds.LOAD_ALL_START, loadAllWorker)
}

function* loadWorker(action: IThiSinhActionTypes): any {
    const payload = action.payload as IThiSinhActionTypeBase<undefined>
    const phongThiId = payload.phongThiId;
    const res: IBaseRespone = yield call(thiSinhApi.SelectByPhong, phongThiId)
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS({
            data: res.data,
            phongThiId
        }))
    } else {
        yield put(mainAction.LOAD_ERROR({
            data: res.message ?? "Có lỗi",
            phongThiId
        }))
    }
}

function* updateWorker(action: IThiSinhActionTypes): any {
    const payload = action.payload as IThiSinhActionTypeBase<IThiSinh[]>
    const phongThiId = payload.phongThiId;
    const res: IBaseRespone = yield call(thiSinhApi.Updates, payload.data)
    if (res.is_success) {
        yield put(mainAction.UPDATES_SUCCESS({
            data: res.data,
            phongThiId
        }))
    } else {
        yield put(mainAction.UPDATES_ERROR({
            data: res.message ?? "Có lỗi",
            phongThiId
        }))
    }
}

function* insertWorker(action: IThiSinhActionTypes): any {
    const payload = action.payload as IThiSinhActionTypeBase<IThiSinh[]>
    const phongThiId = payload.phongThiId;
    const res: IBaseRespone = yield call(thiSinhApi.Updates, payload.data)
    if (res.is_success) {
        yield put(mainAction.INSERTS_SUCCESS({
            data: res.data,
            phongThiId
        }))
    } else {
        yield put(mainAction.INSERTS_ERROR({
            data: res.message ?? "Có lỗi",
            phongThiId
        }))
    }
}

function* saveWorker(action: IThiSinhActionTypes): any {
    const payload = action.payload as IThiSinhActionTypeBase<IThiSinh>
    const phongThiId = payload.phongThiId;
    const monThi = payload.data as IThiSinh
    let res: IBaseRespone;
    if (monThi.id_dot_thi_phong > 0) {
        res = yield call(thiSinhApi.Update, monThi)
    } else {
        res = yield call(thiSinhApi.Insert, monThi)
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS({
            data: res.data,
            phongThiId
        }))
    } else {
        yield put(mainAction.SAVE_ERROR({
            data: res.message ?? "Có lỗi",
            phongThiId
        }))
    }
}

function* deleteWorker(action: IThiSinhActionTypes): any {
    const payload = action.payload as IThiSinhActionTypeBase<number[]>
    const phongThiId = payload.phongThiId;
    const res: IBaseRespone = yield call(thiSinhApi.Deletes, {
        ids: payload.data
    })
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS({
            data: payload.data,
            phongThiId
        }))
    } else {
        yield put(mainAction.DELETE_ERROR({
            data: res.message ?? "Có lỗi",
            phongThiId
        }))
    }
}

function* generateSBDWorker(action: IThiSinhActionTypes): any {
    const payload = action.payload as IThiSinhActionTypeBase<ThiSinhGenerateSBDRequest>
    const phongThiId = payload.phongThiId;
    const res: IBaseRespone = yield call(thiSinhApi.GenerateSBD, payload.data)
    if (res.is_success) {
        yield put(mainAction.GENERATE_SBD_SUCCESS({
            data: payload.data,
            phongThiId
        }))
    } else {
        yield put(mainAction.GENERATE_SBD_ERROR({
            data: res.message ?? "Có lỗi",
            phongThiId
        }))
    }
}


function* loadAllWorker(action: IThiSinhActionTypes): any {
    const payload = action.payload as IThiSinhActionTypeBase<number>
    const id_dot_thi = payload.data;
    const res: IBaseRespone = yield call(thiSinhApi.SelectAllByDotThi, id_dot_thi)
    if (res.is_success) {
        yield put(mainAction.LOAD_ALL_SUCCESS({
            data: res.data,
            phongThiId: 0
        }))
    }
}